import sessionReplay from './session-replay-factory';
export var init = sessionReplay.init, setSessionId = sessionReplay.setSessionId, getSessionId = sessionReplay.getSessionId, getSessionReplayProperties = sessionReplay.getSessionReplayProperties, flush = sessionReplay.flush, shutdown = sessionReplay.shutdown;
export { SafeLoggerProvider } from './logger';
//# sourceMappingURL=index.js.map